import type { AppRole } from "./types";

// Canonical backend roles that should be returned by /api/auth/login.
const CANONICAL_BACKEND_ROLE_MAP: Record<string, AppRole> = {
  SECURITY: "gate",
  ADMIN: "admin-hr",
  HR: "admin-hr",
  HOST: "employee",
};

// Legacy aliases kept for backward compatibility with older tokens/snapshots.
const BACKEND_ROLE_ALIASES: Record<string, string> = {
  GATE: "SECURITY",
  EMPLOYEE: "HOST",
  ADMIN_HR: "HR",
  "ADMIN-HR": "HR",
};

function normalizeRole(value: string): string {
  return value.trim().toUpperCase();
}

function toCanonicalBackendRole(role: string): string {
  const normalized = normalizeRole(role);
  return BACKEND_ROLE_ALIASES[normalized] ?? normalized;
}

export function mapBackendRoleToAppRole(role: string): AppRole | null {
  if (!role) return null;
  return CANONICAL_BACKEND_ROLE_MAP[toCanonicalBackendRole(role)] ?? null;
}

export function getRoleLabel(role: AppRole): string {
  if (role === "gate") return "Gate";
  if (role === "admin-hr") return "Admin-HR";
  return "Employee";
}

export function getRoleDashboardPath(role: AppRole): string {
  if (role === "gate") return "/dashboard/gate";
  if (role === "admin-hr") return "/dashboard/admin-hr";
  return "/dashboard/employee";
}
